// Phase W0 — single source of truth for host → tenant-slug resolution.
//
// Pre-W0 there were three private copies of getTenantSlug() (api.js,
// BrandingContext, Login), all hardcoded to *.euphoricai.io — a white-label
// host like imiways.avanti.ai resolved to NO tenant and the app fell over.
//
// Rules (in order):
//   1. {slug}.euphoricai.io           → slug            (the classic platform host)
//   2. Vercel previews / localhost / IPs → null         (dev fallback below)
//   3. any other host with ≥3 labels  → first label     (white-label apex:
//      imiways.avanti.ai → "imiways"; the backend validates the slug exists,
//      so an unregistered host simply fails login — no spoofing surface)
//
// A bare apex (avanti.ai, 2 labels) is not a tenant host → null.
//
// One override sits above all of it: the demo domain switch (profile menu →
// Switch Domain) stores the tenant it moved you to. It has to win even on a
// real {slug}.euphoricai.io host, because the whole point is to sit on
// staging.euphoricai.io and render praxia. This is not a trust boundary — an
// authenticated request takes its tenant from the JWT, never from this header
// (see routers/visa_programs.py:193) — so the worst a forged value can do is
// mislabel your own audit rows. It is only set alongside a token the backend
// minted for that tenant.
const IP_RE = /^\d{1,3}(\.\d{1,3}){3}$/;

export const DEMO_SLUG_KEY = 'demo_tenant_slug';

export function getTenantSlug() {
  const hostname = window.location.hostname;
  try {
    const demo = localStorage.getItem(DEMO_SLUG_KEY);
    if (demo) return demo;
  } catch { /* private mode — fall through to the host rules */ }
  if (hostname.endsWith('.euphoricai.io')) return hostname.split('.')[0];
  if (
    hostname === 'localhost' ||
    hostname.endsWith('.vercel.app') ||
    IP_RE.test(hostname)
  ) {
    // Dev fallback — lets local dev impersonate a tenant.
    try { return localStorage.getItem('dev_tenant_slug') || null; } catch { return null; }
  }
  const labels = hostname.split('.');
  if (labels.length >= 3 && labels[0]) return labels[0];
  return null;
}
